{
  "colorFormat": "Formato colore",
  "hex": "Esadecimale",
  "hsb": "HSB",
  "hsl": "HSL",
  "rgb": "RGB"
}
